import { useState } from 'react'

import { API } from '@/api'
import PencilIcon from '@/assets/icons/pencil.svg?react'
import { LabelType } from '@/consts/machine'
import { Instance } from '@/models/instance'

interface EditableInstanceNameProps {
  instance: Instance
  onUpdate: () => void
  editable?: boolean
}

export function EditableInstanceName({
  instance,
  onUpdate,
  editable = true,
}: EditableInstanceNameProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [label, setLabel] = useState(instance.displayTitle)

  const handleBlur = async () => {
    setIsEditing(false)
    const newLabel = label.trim()
    if (newLabel === instance.displayTitle) {
      return
    }

    if (newLabel === '') {
      if (instance.flag) {
        await API.deleteLabel({ id: instance.flag.id })
        onUpdate()
      }
    } else {
      if (instance.flag) {
        await API.modifyLabel({
          id: instance.flag.id,
          subject: newLabel,
          type: LabelType.Instance,
        })
      } else {
        await API.createLabel({
          source_id: instance.id,
          subject: newLabel,
          type: LabelType.Instance,
        })
      }
      onUpdate()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      ;(e.target as HTMLInputElement).blur()
    }
  }

  if (isEditing) {
    return (
      <input
        className="bg-neutral-100 h-6 w-30 px-2 py-0.5 t-sb focus-within:outline-none rounded-md"
        name="name"
        autoFocus
        maxLength={30}
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
    )
  }

  return (
    <div className="t-sb flex items-center">
      {instance.displayTitle}
      {editable && (
        <PencilIcon
          className="w-4 h-4 ml-2 text-highlight cursor-pointer hidden group-hover:inline-block"
          onClick={(e) => {
            e.stopPropagation()
            setIsEditing(true)
          }}
        />
      )}
    </div>
  )
}
